export const CURRENT_FISCAL_YEAR = 'CURRENT_FISCAL_YEAR';
export const MY_TEAM_ACCORDION_STATE = 'MY_TEAM_ACCORDION_STATE';
export const SEEN_NOTICE_IDS_KEY = 'lms_seen_notice_ids';
